
import { mapGetters } from 'vuex'

import seoTags from "@/mixins/seoTags";

export default {
	mixins: [seoTags],
	mounted() {
		setTimeout(function () { window.scrollTo(0, -100); }, 1);
	},
	computed: {
		...mapGetters({
			benefitsCredit: 'benefits/benefitsCredit',
			benefitsCredit_slider: 'benefits/benefitsCredit_slider',
			benefits_autoCredit: 'benefits/benefits_autoCredit'

		}),
	},
}
